/**
 * BaseEventSchema — the standard body every PostHog event carries.
 *
 * Per ``plans/PLAN_POSTHOG_05_GOVERNANCE.md`` § "Standard body —
 * mandatory on every event", these three fields are universal:
 *
 *   - ``app``         constant ``"mi-platform"``
 *   - ``app_version`` build-time git sha
 *   - ``ui_version``  manually bumped per design refresh
 *
 * Module-scoped events also carry ``module`` (the ``ModuleType`` value);
 * frontend UI events also carry ``screen`` (``<area>/<entity>`` slug)
 * and ``feature``. These are optional on the base so each per-event
 * schema can override them as required where needed.
 *
 * Every per-event schema extends this object via
 * ``BaseEventSchema.extend({ event_name: z.literal("..."), ... })`` so
 * the discriminated union in ``registry.ts`` enforces the standard
 * body at compile time.
 */

import { z } from "zod";

export const BaseEventSchema = z.object({
  app: z.literal("mi-platform"),
  app_version: z.string(),
  ui_version: z.string(),
  module: z.string().optional(),
  screen: z.string().optional(),
  feature: z.string().optional(),
});

export type BaseEvent = z.infer<typeof BaseEventSchema>;
